var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkmode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dark mode"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 18.0621H6.57009C3.22204 18.0621 0.507935 15.3479 0.507935 11.9999C0.507935 8.65185 3.22204 5.93774 6.57009 5.93774H12C15.348 5.93774 15.348 18.0621 12 18.0621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.4299 5.93774H12V18.062H17.4299C20.778 18.062 23.4921 15.3479 23.4921 11.9999C23.4921 8.65185 20.778 5.93774 17.4299 5.93774Z",
    fill: "#9DC6FB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.08857 15.1586C7.83311 15.1586 9.24734 13.7444 9.24734 11.9998C9.24734 10.2553 7.83311 8.84106 6.08857 8.84106C4.34404 8.84106 2.92981 10.2553 2.92981 11.9998C2.92981 13.7444 4.34404 15.1586 6.08857 15.1586Z",
    fill: "#1D75D9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.5913 11.9998C17.5913 10.7782 18.5816 9.78794 19.8032 9.78794C19.9756 9.78794 20.1434 9.80767 20.3045 9.84503C19.7279 9.22727 18.9065 8.84106 17.9948 8.84106C16.2503 8.84106 14.8361 10.2553 14.8361 11.9998C14.8361 13.7444 16.2503 15.1586 17.9948 15.1586C18.9065 15.1586 19.7279 14.7723 20.3045 14.1546C20.1434 14.1919 19.9756 14.2117 19.8032 14.2117C18.5816 14.2116 17.5913 13.2213 17.5913 11.9998Z",
    fill: "#FFDC1E"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkmode);
export default __webpack_public_path__ + "static/media/Darkmode.d606ddddeadf7c2ea49fee9d14d6c611.svg";
export { ForwardRef as ReactComponent };